import React from "react";
import { Card, makeStyles } from "@material-ui/core";
import { Draggable } from "react-beautiful-dnd";
import IconPdf from '../../assets/pdfIcon.png'
import IconExcel from '../../assets/excelIconVerde.png'
import IconGeneric from '../../assets/generic.png'

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 5,
    padding: "5px 5px",
    width: "100%",
    height: "auto",
    boxShadow: "2px 2px 20px black",
    display: "flex",
    justifyContent: "center",

  },
  cardInside: {
    height: 120,
    display: "flex",
    justifyContent: "center",
  },
}));

export default React.forwardRef(function CarouselSlide(props, ref) {
  const classes = useStyles();

  const { url, id } = props.content;
  const { indice } = props;

  const esImagen = (url) => {
    let result = false;
    if (url.toLowerCase().search("pdf") === -1 && url.toLowerCase().search("xls") === -1 && url.toLowerCase().search("xlsx") === -1) {
      result = true;
    }
    return result
  }

  const getOtherMedia = (url) => {
    if (url.toLowerCase().search(".xls") !== -1 || url.toLowerCase().search(".xlsx") !== -1) {
      return IconExcel
    } else if (url.search(".pdf") !== -1) {
      return IconPdf
    } else {
      return IconGeneric
    }
  }

  return (
    <Draggable key={url} draggableId={`documentacion${id}`} index={indice}>
      {
        (provided) => (
          <Card className={classes.card} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
            <div className={classes.cardInside}>
              <img alt="Imagen No Disponible" src={esImagen(url)  ? url : getOtherMedia(url)} />
            </div>
          </Card>
        )
      }
    </Draggable>
  );
})
